"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreSearchModal = exports.StoreSearch = void 0;
require("./StoreSearch.scss");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var contants_1 = require("../lib/contants");
var modal_1 = require("../lib/modal/modal");
var NsrAddonApi_1 = require("../lib/NsrAddonApi");
var util_1 = require("../lib/util");
var StoreSearch = /** @class */ (function () {
    function StoreSearch(infoArea, cafe24Prod, options) {
        this.infoArea = infoArea;
        this.cafe24Prod = cafe24Prod;
        this.options = options;
    }
    StoreSearch.prototype.init = function () {
        var _this = this;
        var $link = util_1.$element('a', 'nsr-addon-store-search-launcher')
            .setText('매장 재고알림 서비스')
            .on('click', function () {
            new StoreSearchModal(_this.cafe24Prod, _this.options).show();
        });
        var sizeCont = util_1.$helper(this.infoArea).findFirst('.size_cont');
        if (sizeCont) {
            var sizeContChild = sizeCont.querySelector(':first-child');
            if (sizeContChild) {
                util_1.before(sizeContChild, $link.element);
            }
            else {
                util_1.append(sizeCont, $link.element);
            }
        }
        else {
            var tbodyProductOption = util_1.$helper(this.infoArea).findFirst('tbody.xans-product-option');
            if (tbodyProductOption) {
                util_1.after(tbodyProductOption, util_1.$div('p').tap(function ($) { return $.element.style.margin = '.5rem 0'; }).append($link.element));
            }
        }
    };
    return StoreSearch;
}());
exports.StoreSearch = StoreSearch;
var StoreSearchModal = /** @class */ (function (_super) {
    __extends(StoreSearchModal, _super);
    function StoreSearchModal(cafe24Prod, options) {
        var _this = _super.call(this, {
            title: '매장안내 - ' + cafe24Prod.product_name,
            fullsize: options.fullsize,
            animation: options.fullsize ? undefined : 'move-up',
            position: options.fullsize ? undefined : 'bottom'
        }) || this;
        _this.cafe24Prod = cafe24Prod;
        _this.area = contants_1.AREA_FILTER_OPTIONS[0];
        _this.selection = {};
        _this.listReq$ = new rxjs_1.Subject();
        _this.fullsize = options.fullsize;
        _this.listReq$
            .pipe(operators_1.takeUntil(_this.destroy$), operators_1.switchMap(function (params) {
            _this.stores = 'loading';
            return NsrAddonApi_1.NsrAddonApi.listProdInvenStores(params).pipe(operators_1.catchError(function () {
                _this.stores = undefined;
                return rxjs_1.EMPTY;
            }));
        }))
            .subscribe(function (res) {
            _this.stores = res.data;
        });
        return _this;
    }
    Object.defineProperty(StoreSearchModal.prototype, "stores", {
        set: function (stores) {
            this._stores = stores;
            this.renderStores(stores);
        },
        enumerable: false,
        configurable: true
    });
    StoreSearchModal.prototype.onInit = function () {
        _super.prototype.onInit.call(this);
        this.view = this.createView();
        _super.prototype.setContent.call(this, this.view);
    };
    StoreSearchModal.prototype.createView = function () {
        var _this = this;
        return util_1.$div('nsr-addon nsr-addon-store-search')
            .tap(function ($) {
            if (_this.fullsize)
                $.addClass('fullsize');
        })
            .append(this.createSidePanel(), this.createMainPanel());
    };
    StoreSearchModal.prototype.createSidePanel = function () {
        return util_1.$div('side-panel').append(util_1.$div('vl-right'), this.createAreaSelectors());
    };
    StoreSearchModal.prototype.createMainPanel = function () {
        return util_1.$div('main-panel').append(this.createOptionSelectors(), util_1.$div('search-result'));
    };
    StoreSearchModal.prototype.createAreaSelectors = function () {
        var _this = this;
        var $ul = util_1.$element('ul', 'area-selector');
        var _loop_1 = function (area) {
            $ul.append(util_1.$element('li', 'area-value', { area_value: area })
                .tap(function ($) {
                if (area === _this.area)
                    $.addClass('active');
            })
                .setText(area)
                .on('click', function () { return _this.onSelectArea(area); }));
        };
        for (var _i = 0, AREA_FILTER_OPTIONS_1 = contants_1.AREA_FILTER_OPTIONS; _i < AREA_FILTER_OPTIONS_1.length; _i++) {
            var area = AREA_FILTER_OPTIONS_1[_i];
            _loop_1(area);
        }
        return $ul;
    };
    StoreSearchModal.prototype.createOptionSelectors = function () {
        var _a;
        var _this = this;
        var options = this.reduceOptions();
        var selectors = lodash_1.map(options, function (option) { return _this.createOptionSelector(option); });
        return (_a = util_1.$div('search-filters')).append.apply(_a, selectors);
    };
    StoreSearchModal.prototype.createOptionSelector = function (option) {
        var _this = this;
        var $ul = util_1.$element('ul', 'option-selector').setAttr('option_name', option.option_name);
        var _loop_2 = function (option_value) {
            $ul.append(util_1.$element('li', 'option-value')
                .setAttr('option_value', option_value.option_text_alias || option_value.option_text)
                .setText(option_value.option_text)
                .on('click', function () { return _this.onSelectOption(option.option_name, option_value.option_text_alias || option_value.option_text); }));
        };
        for (var _i = 0, _a = option.option_values; _i < _a.length; _i++) {
            var option_value = _a[_i];
            _loop_2(option_value);
        }
        return util_1.$div('d-flex flex-row mb-2').append(util_1.$element('label', 'option-name').setText(option.option_name), $ul);
    };
    StoreSearchModal.prototype.reduceOptions = function () {
        var cp = this.cafe24Prod;
        var options = cp.options;
        var variants = cp.variants;
        return lodash_1.map(options.options, function (o) {
            var option_name = o.option_name;
            var option_values = lodash_1.filter(o.option_value, function (option_value) {
                var hasVariants = lodash_1.find(variants, function (variant) {
                    return lodash_1.find(variant.options, { name: option_name, value: option_value.option_text })
                        ? true
                        : false;
                });
                return hasVariants ? true : false;
            });
            return {
                option_name: option_name,
                option_values: option_values,
            };
        });
    };
    StoreSearchModal.prototype.onShown = function () {
        this.onSearch(this.area, this.selection);
    };
    StoreSearchModal.prototype.onSelectArea = function (area_value) {
        var ul = this.view.findFirst('.area-selector');
        if (!ul)
            throw new Error('Not found .area-selector');
        var li = ul.querySelector(".area-value[area_value=\"" + area_value + "\"]");
        if (!li)
            throw new Error('No such area_value: ' + area_value);
        ul.querySelectorAll(".area-value:not([area_value=\"" + area_value + "\"])").forEach(function (li) {
            return li.classList.remove('active');
        });
        li.classList.add('active');
        this.area = area_value;
        this.onSearch(this.area, this.selection);
    };
    StoreSearchModal.prototype.onSelectOption = function (option_name, option_value) {
        var ul = this.view.findFirst(".option-selector[option_name=\"" + option_name + "\"]");
        if (!ul)
            throw new Error('No such option_name: ' + option_name);
        if (option_value === null || option_value === undefined) {
            ul.querySelectorAll(".option-value").forEach(function (li) { return li.classList.remove('active'); });
        }
        else {
            var li = ul.querySelector(".option-value[option_value=\"" + option_value + "\"]");
            if (!li)
                throw new Error('No such option_value: ' + option_value + ' in option_name: ' + option_name);
            ul.querySelectorAll(".option-value:not([option_value=\"" + option_value + "\"])").forEach(function (li) {
                return li.classList.remove('active');
            });
            li.classList.add('active');
        }
        this.selection[option_name] = option_value;
        this.onSearch(this.area, this.selection);
    };
    StoreSearchModal.prototype.onSearch = function (area, selection) {
        var _a, _b;
        var cp = this.cafe24Prod;
        var options = cp.options;
        var option_name_color = (_a = options.options[0]) === null || _a === void 0 ? void 0 : _a.option_name;
        var option_name_size = (_b = options.options[1]) === null || _b === void 0 ? void 0 : _b.option_name;
        this.listReq$.next({
            prno: cp.product_no,
            color: selection[option_name_color] || undefined,
            size: selection[option_name_size] || undefined,
            custom_prcd: cp.custom_product_code || undefined,
            area: (area !== '전국' ? area : undefined),
        });
    };
    StoreSearchModal.prototype.renderStores = function (stores) {
        var result = this.$element.findFirst('.search-result');
        if (!result)
            return;
        var $result = util_1.$helper(result).empty();
        if (lodash_1.isArray(stores)) {
            if (stores.length) {
                var $ul = util_1.$element('ul', 'store-list');
                for (var _i = 0, stores_1 = stores; _i < stores_1.length; _i++) {
                    var store = stores_1[_i];
                    $ul.append(this.renderStore(store));
                }
                $result.append($ul);
            }
            else {
                $result.append(util_1.$div('message').setText('해당하는 매장이 없습니다'));
            }
        }
        else if (stores === 'loading') {
            $result.append(util_1.$div('loader loader-md'));
        }
        else {
            $result.append(util_1.$div('message').setText('해당 상품에 대한 매장 정보가 없습니다'));
        }
    };
    StoreSearchModal.prototype.renderStore = function (store) {
        var _this = this;
        return util_1.$element('li', 'store-item')
            .append(util_1.$div('title').setText(store.title))
            .tap(function ($) {
            if (store.addr)
                $.append(util_1.$div('addr').setText(store.addr));
            if (store.tel)
                $.append(util_1.$div('tel').setText(store.tel));
            if (store.opentime)
                $.append(util_1.$div('opentime').setText(store.opentime));
        })
            .on('click', function () { return _this.onClickStore(store); });
    };
    StoreSearchModal.prototype.onClickStore = function (store) {
        // console.log('store:', store);
    };
    return StoreSearchModal;
}(modal_1.ModalComponent));
exports.StoreSearchModal = StoreSearchModal;
